import React from 'react';
import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';
import * as api from 'api';
import * as actionCreators from 'store/actions';
import { customList } from 'country-codes-list';
import _ from 'lodash';

import { Button, Spinner, FormField } from 'components'

const Container = styled.div`
    display: grid;
    grid-template-columns: 100%;
    grid-template-rows: auto auto auto auto;
    grid-gap: 0.5rem;
    margin-top: 0.2rem;
`

const ButtonContainer = styled.div`
    display: flex;
    justify-content: flex-end;
    /* grid-column: 1/ span 2; */
`

const Error = styled.div`
    font-size: 0.9rem;
    color: var(--error-color);
    margin-top: 0.2rem;
    :before {
        content: '*'
    }
`
let countryRef = customList('countryCode', '{countryNameEn}')
countryRef = Object.entries(countryRef)
    .sort(([,a],[,b]) => a < b ? -1 : 1)
    .reduce((r, [k, v]) => ({ ...r, [k]: v }), {});

const BillingAddressInput = props => {
    const { 
        address,
        onClose
    } = props;
    const dispatch = useDispatch()
    const user = useSelector((state) => state.auth.user)
    const [value, setValue] = React.useState(address)
    const [selected, setSelected] = React.useState(false)
    const [showSpinner, setSpinner] = React.useState(false)
    const [error, setError] = React.useState(false)

    const onKeyDownHandler = (event) => {
        if (event.keyCode === 13 ) {
            onSubmit()
        } else if (event.keyCode === 27) {
            onClose && onClose()
        }
    }

    const onSubmit = () => {
        const debug = false
        setSpinner(true)
        setError(null)
        console.log(value)
        if(JSON.stringify(value) !== JSON.stringify(address)){
            api.updateCustomer({ userId: user['uid'], updates: { address: value }})
            .then(res => {
                debug && console.log('[BillingAddressInput] Address updated')
                dispatch(actionCreators.updateCustomer(res.data['customer']))
                onClose && onClose()
                setSpinner(false)
            })
            .catch(err => {
                debug && console.log('[BillingAddressInput] Address not updated')
                setSpinner(false)
                setError('Changes not made')
            })
        } else {
            onClose && onClose()
        }
    }

    const onChange = (v, key) => {
        let updatedValue = {...value}
        updatedValue[key] = v
        console.log(updatedValue)
        setValue(updatedValue)
        setError(null)
    }

    return (
        <Container>
            {/* Country input */}
            <FormField type='DROPDOWN' label='Country' value={countryRef[value['country']]} 
                options={countryRef}
                onSelect={(value) => onChange(value, 'country')}
                style={{margin: 0, labelWeight: 'normal', fontSize: '1rem', fieldPadding: 0, padding: '0.2rem 0.5rem', optionPadding: '0.5rem 0.5rem'}}/>

            {/* Line 1 input */}
            <FormField type='TEXT' label='Line 1' value={value['line1']} selected={selected === 'line1'} maxLength={255}
                onChange={(value) => onChange(value, 'line1')} onKeyDown={onKeyDownHandler} 
                onFocus={() => setSelected('line1')} onBlur={() => setSelected(null)}
                style={{margin: 0, labelWeight: 'normal'}}/>
            
            {/* Line 2 input */}
            <FormField type='TEXT' label='Line 2' value={value['line2']} selected={selected === 'line2'} maxLength={255}
                onChange={(value) => onChange(value, 'line2')} onKeyDown={onKeyDownHandler} 
                onFocus={() => setSelected('line2')} onBlur={() => setSelected(null)}
                style={{margin: 0, labelWeight: 'normal'}}/>
            
            {/* Postal code input */}
            <FormField type='TEXT' label='Postal code' value={value['postal_code']} selected={selected === 'postal_code'} maxLength={15}
                onChange={(value) => onChange(value, 'postal_code')} onKeyDown={onKeyDownHandler}  
                onFocus={() => setSelected('postal_code')} onBlur={() => setSelected(null)}
                style={{margin: 0, labelWeight: 'normal'}}/>
            
            {/* Error */}
            {error && <Error>Changes not made</Error>}

            {/* Buttons */}
            <ButtonContainer>
                <Button text='Cancel' onSelect={onClose} styles={{backgroundColor:'var(--primary-color)', margin: '0 0.5rem', boxShadowColor: 'transparent'}}/>
                <Button text={showSpinner ? <Spinner styles={{color: 'var(--text-color)'}}/> : 'Save'}
                    onSelect={onSubmit} 
                    styles={{backgroundColor: 'var(--focus-color)', margin: 0, color: 'white'}} />
            </ButtonContainer>
        </Container>
    )
}

export default BillingAddressInput